<template>
  <div class="d-flex align-center justify-center full--height">
    <v-card outlined max-width="350px">
      <div class="d-flex justify-space-between align-center px-4 py-2">
        <h3 v-text="$t('account.passwordNewTitle')"></h3>
      </div>
      <v-divider></v-divider>
      <v-progress-linear
        :active="isLoading"
        :indeterminate="isLoading"
        bottom
        color="secondary"
      ></v-progress-linear>
      <v-form
        ref="newPasswordAccount"
        v-model="valid"
        lazy-validation
        class="pa-4"
        v-if="!passwordChanged"
      >
        <!-- PasswordInput -->
        <v-text-field
          outlined
          v-bind:label="$t('account.password')"
          :type="showPassword ? 'text' : 'password'"
          color="primary"
          v-model="password"
          :rules="passwordRules"
          required
          ref="passwordInput"
          :append-icon="showPassword ? 'visibility' : 'visibility_off'"
          @click:append="showPassword = !showPassword"
          :error-messages="$t(errors.passwordInput)"
          @focus="removeInputErrorMessage('passwordInput')"
          @input="removeInputErrorMessage('passwordInput')"
        >
        </v-text-field>

        <!-- ConfirmPasswordInput -->
        <v-text-field
          outlined
          name="confirmPassword"
          v-bind:label="$t('account.confirmPassword')"
          :type="showConfirmPassword ? 'text' : 'password'"
          color="primary"
          v-model="confirmPassword"
          :rules="confirmPasswordRules"
          required
          :append-icon="showConfirmPassword ? 'visibility' : 'visibility_off'"
          @click:append="showConfirmPassword = !showConfirmPassword"
        >
        </v-text-field>
        <v-btn
          color="primary"
          large
          block
          @click="newPasswordAccount()"
          :disabled="!valid"
          v-text="$t('account.editPassword')"
        >
        </v-btn>
      </v-form>
      <div v-else class="pa-4">
        <v-alert
          text
          outlined
          :color="alertState === 'success' ? 'success' : 'error'"
          v-model="alertDisplay"
          icon="info"
        >
          {{ alertMessage }}
        </v-alert>
        <v-btn
          v-if="alertState === 'success'"
          color="primary"
          large
          block
          @click="
            $router.push({ name: 'home' });
            $store.dispatch('navigation/openLoginView');
          "
          v-text="$t('account.login')"
        >
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
/* SERVICES */
import AccountService from "../../account/services/AccountService";
import ErrorInputMixins from "./../../services/ErrorInputMixins";
import ErrorToDisplay from "../../core/classes/ErrorToDisplay";

export default {
  mixins: [ErrorInputMixins],
  props: {
    uid: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      valid: true,
      isLoading: false,
      password: null,
      showPassword: false,
      passwordRules: [
        () =>
          this.passwordAtLeastEightCharacters ||
          this.$i18n.t("account.rules.password.atLeastEigthCharacters"),
        () =>
          this.passwordAtleastOneNumber ||
          this.$i18n.t("account.rules.password.atleastOneNumber"),
        () =>
          this.passwordAtleastOneCapitalLetter ||
          this.$i18n.t("account.rules.password.atleastOneCapitalLetter"),
        () =>
          this.passwordNoSpace || this.$i18n.t("account.rules.password.noSpace")
      ],
      confirmPassword: null,
      showConfirmPassword: false,
      confirmPasswordRules: [
        () =>
          this.passwordAndConfirmPasswordAreEqual ||
          this.$i18n.t(
            "account.rules.password.passwordAndConfirmPasswordArentEqual"
          )
      ],
      alertDisplay: false,
      alertState: "success",
      alertMessage: null,
      passwordChanged: false
    };
  },
  computed: {
    passwordAtLeastEightCharacters() {
      return /^.*(?=.{8,}).*$/.test(this.password);
    },
    passwordAtleastOneNumber() {
      return /^.*(?=.*\d).*$/.test(this.password);
    },
    passwordAtleastOneCapitalLetter() {
      return /^.*((?=.*[A-Z]){1}).*/.test(this.password);
    },
    passwordNoSpace() {
      return /^\S*$/.test(this.password);
    },
    passwordAndConfirmPasswordAreEqual() {
      return this.password === this.confirmPassword;
    }
  },
  methods: {
    newPasswordAccount() {
      if (this.$refs.newPasswordAccount.validate()) {
        this.isLoading = true;
        AccountService.newPasswordAccount(this.uid, this.token, this.password)
          .then(() => {
            this.alertMessage = this.$t(
              "account.successMessageAfterResetPasswordAccount"
            );
            this.passwordChanged = true;
            this.alertDisplay = true;
          })
          .catch(error => {
            this.triggerInputAlert(new ErrorToDisplay(error.response));
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    }
  }
};
</script>
